// extracted by mini-css-extract-plugin
module.exports = {"cardOptionWorkspaceAds":"CardOptionWorkspaceAds_cardOptionWorkspaceAds__262lI","cardOptionWorkspaceAdsHeader":"CardOptionWorkspaceAds_cardOptionWorkspaceAdsHeader__2oJtm"};